import {
  SHELL_RUNTIME_BANNER_EVENT,
  SHELL_RUNTIME_OPEN_NOTIFICATIONS_DRAWER_EVENT,
  SHELL_RUNTIME_TOAST_EVENT,
  type ShellUiBannerInput,
  type ShellUiClient,
  type ShellUiNotificationsDrawerRequest,
  type ShellUiToastInput,
} from "@shared/host/shell-runtime";

const dispatchShellUiEvent = <TDetail,>(
  eventName: string,
  detail: TDetail,
) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const createShellUiClient = (): ShellUiClient => ({
  toast: (input: ShellUiToastInput) => {
    dispatchShellUiEvent(SHELL_RUNTIME_TOAST_EVENT, input);
  },
  banner: (input: ShellUiBannerInput) => {
    dispatchShellUiEvent(SHELL_RUNTIME_BANNER_EVENT, input);
  },
  openNotificationsDrawer: (
    request: ShellUiNotificationsDrawerRequest = {},
  ) => {
    dispatchShellUiEvent(
      SHELL_RUNTIME_OPEN_NOTIFICATIONS_DRAWER_EVENT,
      request,
    );
  },
});
